import React from "react";
import { Link } from "react-router-dom";

const StartBuilding: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">

      {/* Hero Section - Exact replica of Raspberry Pi design */}
      <section className="pt-28 px-6 mx-16 rounded-lg">
        <div className="container mx-auto max-w-full bg-purple-600 rounded-lg">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left side - Text content */}
            <div className="text-white ml-8">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
                Start your <span className="font-black">coding and computing journey</span>
              </h1>
              <ul className="space-y-3 mb-8 text-lg">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-white rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Hundreds of fun coding projects
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-white rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Easy step-by-step instructions
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-white rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Explore a range of hardware and software
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-white rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  All completely free!
                </li>
              </ul>
            </div>
            
            {/* Right side - Hero SVG Image */}
            <div className="relative flex justify-center items-center p-8">
              <img 
                src="/kids/hero-image.svg" 
                alt="Coding and computing illustration" 
                className="w-full max-w-lg h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Interest Categories Section - Exact match */}
      <section className="py-16 px-6 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-4" style={{fontFamily: 'Lexend, sans-serif'}}>
              What are you interested in?
            </h2>
            <p className="text-lg text-gray-600" style={{fontFamily: 'Lexend, sans-serif'}}>
              Find a project based on a topic you like.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Nature */}
            <Link
              to="/category/nature"
              className="bg-green-200 rounded-lg p-6 flex items-center justify-between hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md group"
            >
              <span className="text-lg font-bold text-black" style={{fontFamily: 'Lexend, sans-serif'}}>Nature &gt;</span>
              <img 
                className="c-interest-card__image w-10 h-10 object-contain" 
                src="/kids/projects/nature-svgrepo-com.svg" 
                alt="Nature"
              />
            </Link>

            {/* Games */}
            <Link
              to="/category/games"
              className="bg-orange-200 rounded-lg p-6 flex items-center justify-between hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md group"
            >
              <span className="text-lg font-bold text-black" style={{fontFamily: 'Lexend, sans-serif'}}>Games &gt;</span>
              <img 
                className="c-interest-card__image w-10 h-10 object-contain" 
                src="/kids/projects/game-svgrepo-com.svg" 
                alt="Games"
              />
            </Link>

            {/* Music */}
            <Link
              to="/category/music"
              className="bg-pink-200 rounded-lg p-6 flex items-center justify-between hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md group"
            >
              <span className="text-lg font-bold text-black" style={{fontFamily: 'Lexend, sans-serif'}}>Music &gt;</span>
              <img 
                className="c-interest-card__image w-10 h-10 object-contain" 
                src="/kids/projects/music-svgrepo-com.svg" 
                alt="Music"
              />
            </Link>

            {/* Space */}
            <Link
              to="/category/space"
              className="bg-blue-200 rounded-lg p-6 flex items-center justify-between hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md group"
            >
              <span className="text-lg font-bold text-black" style={{fontFamily: 'Lexend, sans-serif'}}>Space &gt;</span>
              <img 
                className="c-interest-card__image w-10 h-10 object-contain" 
                src="/kids/projects/space-svgrepo-com.svg" 
                alt="Space"
              />
            </Link>

            {/* Art */}
            <Link
              to="/category/art"
              className="bg-orange-300 rounded-lg p-6 flex items-center justify-between hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md group"
            >
              <span className="text-lg font-bold text-black" style={{fontFamily: 'Lexend, sans-serif'}}>Art &gt;</span>
              <img 
                className="c-interest-card__image w-10 h-10 object-contain" 
                src="/kids/projects/art-svgrepo-com.svg" 
                alt="Art"
              />
            </Link>

            {/* Sports */}
            <Link
              to="/category/sports"
              className="bg-green-100 rounded-lg p-6 flex items-center justify-between hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md group"
            >
              <span className="text-lg font-bold text-black" style={{fontFamily: 'Lexend, sans-serif'}}>Sports &gt;</span>
              <img 
                className="c-interest-card__image w-10 h-10 object-contain" 
                src="/kids/projects/sport-svgrepo-com.svg" 
                alt="Sports"
              />
            </Link>

            {/* Stories */}
            <Link
              to="/category/stories"
              className="bg-indigo-200 rounded-lg p-6 flex items-center justify-between hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md group"
            >
              <span className="text-lg font-bold text-black" style={{fontFamily: 'Lexend, sans-serif'}}>Stories &gt;</span>
              <img 
                className="c-interest-card__image w-10 h-10 object-contain" 
                src="/kids/projects/stories-svgrepo-com.svg" 
                alt="Stories"
              />
            </Link>

            {/* Health */}
            <Link
              to="/category/health"
              className="bg-yellow-200 rounded-lg p-6 flex items-center justify-between hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md group"
            >
              <span className="text-lg font-bold text-black" style={{fontFamily: 'Lexend, sans-serif'}}>Health &gt;</span>
              <img 
                className="c-interest-card__image w-10 h-10 object-contain" 
                src="/kids/projects/health-svgrepo-com.svg" 
                alt="Health"
              />
            </Link>

            {/* Science */}
            <Link
              to="/category/science"
              className="bg-blue-300 rounded-lg p-6 flex items-center justify-between hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md group"
            >
              <span className="text-lg font-bold text-black" style={{fontFamily: 'Lexend, sans-serif'}}>Science &gt;</span>
              <img 
                className="c-interest-card__image w-10 h-10 object-contain" 
                src="/kids/projects/science-svgrepo-com.svg" 
                alt="Science"
              />
            </Link>
          </div>
        </div>
      </section>

      {/* Technology Categories Section */}
      <section className="py-16 px-6 bg-yellow-50">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-4" style={{fontFamily: 'Lexend, sans-serif'}}>
              What do you want to make with?
            </h2>
            <p className="text-lg text-gray-600" style={{fontFamily: 'Lexend, sans-serif'}}>
              Find a project based on a technology you want to use.
            </p>
          </div>
          
          <div className="grid grid-cols-2 gap-6">
            {/* Scratch */}
            <Link
              to="/all-projects"
              className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 group"
            >
              <div className="flex items-start space-x-4">
                <img 
                  className="w-20 h-20 object-contain flex-shrink-0 rounded-lg" 
                  src="/kids/actions/scratch.png" 
                  alt="Scratch"
                />
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-black mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
                    Scratch &gt;
                  </h3>
                  <p className="text-gray-600 text-sm" style={{fontFamily: 'Lexend, sans-serif'}}>
                    Great for beginners! Try coding in this block-based language.
                  </p>
                </div>
              </div>
            </Link>

            {/* Python */}
            <Link
              to="/all-projects"
              className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 group"
            >
              <div className="flex items-start space-x-4">
                <img 
                  className="w-20 h-20 object-contain flex-shrink-0 rounded-lg" 
                  src="/kids/actions/python.webp" 
                  alt="Python"
                />
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-black mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
                    Python &gt;
                  </h3>
                  <p className="text-gray-600 text-sm" style={{fontFamily: 'Lexend, sans-serif'}}>
                    A text-based coding language, try this when you're comfortable with Scratch.
                  </p>
                </div>
              </div>
            </Link>

            {/* Web Development */}
            <Link
              to="/all-projects"
              className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 group"
            >
              <div className="flex items-start space-x-4">
                <img 
                  className="w-20 h-20 object-contain flex-shrink-0 rounded-lg" 
                  src="/kids/actions/web_development.webp" 
                  alt="Web Development"
                />
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-black mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
                    Web development &gt;
                  </h3>
                  <p className="text-gray-600 text-sm" style={{fontFamily: 'Lexend, sans-serif'}}>
                    Design and make web pages using HTML and CSS.
                  </p>
                </div>
              </div>
            </Link>

            {/* AI & Data */}
            <Link
              to="/all-projects"
              className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 group"
            >
              <div className="flex items-start space-x-4">
                <img 
                  className="w-20 h-20 object-contain flex-shrink-0 rounded-lg" 
                  src="/kids/actions/ai_and_data.png" 
                  alt="AI & Data"
                />
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-black mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
                    AI & data &gt;
                  </h3>
                  <p className="text-gray-600 text-sm" style={{fontFamily: 'Lexend, sans-serif'}}>
                    Discover machine learning and AI applications and technologies.
                  </p>
                </div>
              </div>
            </Link>

            {/* Physical Computing */}
            <Link
              to="/all-projects"
              className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 group"
            >
              <div className="flex items-start space-x-4">
                <img 
                  className="w-20 h-20 object-contain flex-shrink-0 rounded-lg" 
                  src="/kids/actions/physical_computing.webp" 
                  alt="Physical Computing"
                />
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-black mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
                    Physical computing &gt;
                  </h3>
                  <p className="text-gray-600 text-sm" style={{fontFamily: 'Lexend, sans-serif'}}>
                    Code something that controls a physical device.
                  </p>
                </div>
              </div>
            </Link>

            {/* 3D & CAD */}
            <Link
              to="/all-projects"
              className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 group"
            >
              <div className="flex items-start space-x-4">
                <img 
                  className="w-20 h-20 object-contain flex-shrink-0 rounded-lg" 
                  src="/kids/actions/3d_and_cad.webp" 
                  alt="3D & CAD"
                />
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-black mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
                    3D & CAD &gt;
                  </h3>
                  <p className="text-gray-600 text-sm" style={{fontFamily: 'Lexend, sans-serif'}}>
                    Create and explore 3D worlds.
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StartBuilding;